export const alertNotifications = [

    {
        notificationID:1234,
        time:10,
        message:"TN07AA1111 vehicle Rc is Expired.",
        title:'Vehicle Notification',
        Icon:'vehicle',
    },
    {
        notificationID:16542,
        time:15,
        message:"Sos form TN32AA1234 vehicle.",
        title:'SOS Notification',
        Icon:'SOs',
    }
];